import React from 'react'

function AboutUs() {
  return (
 
      <div className='mt-6 md:mt-10 flex flex-col lg:flex-row sm:w-[96%]  lg:w-[96%] xl:w-[85%] 2xl:w-[80%] h-auto m-auto '>
        <div className='flex flex-col p-10 sm:w-[80%] w-full lg:w-[50%] text-white '>
          <h1 className='text-xl sm:text-2xl md:text-3xl lg:text-3xl 2xl:text-3xl font-bold'>About US</h1>
          <h2 className='text-lg sm:text-xl md:text-2xl lg:text-xl 2xl:text-2xl mt-6 md:mt-8'>Our Mission</h2>
          <p className='text-md sm:text-lg md:text-lg lg:text-base xl:text-lg mt-4 md:mt-6 text-nav_option'>At Fit Streak, our mission is to empower individuals to achieve their fitness 
            goals and lead healthier, more confident lives. We are committed to 
            providing a welcoming and supportive environment equipped with state 
            of the art facilities and expert trainers who inspire and guide every step 
            of the way.</p>
          <h2 className='text-lg sm:text-xl md:text-2xl lg:text-xl 2xl:text-2xl mt-6 md:mt-8'>Our Vision</h2>
          <p className='text-md sm:text-lg md:text-lg lg:text-base xl:text-lg mt-4 md:mt-6 text-nav_option'>
            Our vision is to build a vibrant fitness community where people of all 
            backgrounds can discover their potential, break barriers, and transform 
            their lives. By fostering a culture of passion, dedication, and innovation, 
            Fit Streak strives to become a leader in the fitness industry and a trusted 
            partner in every fitness journey.
          </p>
        </div>
        <div className='flex flex-col w-full h-full  lg:w-[50%] lg:h-auto justify-end '>
            <img
                src="/images/aboutUs.png"
                alt="maleTrainer"
                className='w-[280px] sm:w-[450px] h-auto md:w-[600px] object-cover ml-auto mt-auto mr-auto '
            />
        </div>

      </div>
  
  )
}

export default AboutUs
